import React, { useState, useEffect, useRef } from "react";
import { getUsers } from "../services/soar";
import Select from "../common/Select";
import ReportsExpand from "../common/ReportsExpand";
import Input from "./../common/Input";
import { getFieldName } from "../../scripts/helperScripts";

function CaseWorkerNoteSummary({
  divisions,
  isFavorite,
  toggleFavorite,
  ...rest
}) {
  const [reportData, setReportData] = useState({
    State: "",
    Caseworker: "",
    BeginDate: "",
    EndDate: "",
  });
  const [users, setUsers] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [caseworkerOptions, setCaseworkerOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMountedRef = useRef(true);
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    console.log("Filter Users by Selected State");
    if (reportData.State !== "") {
      let caseworkerArray = [];

      let filteredCaseworkers = users.filter(
        (u) => getFieldName(u.businessunitid) === reportData.State
      );

      filteredCaseworkers.forEach((user) => {
        if (!caseworkerArray.some((x) => x._id === user.systemuserid)) {
          caseworkerArray.push({
            _id: user.systemuserid,
            name: user.fullname,
          });
        }
      });

      setCaseworkerOptions(caseworkerArray);
    }
  }, [reportData.State, users]);

  const handleChange = ({ currentTarget: input }) => {
    console.log("input: ", input, input.value);
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  const handleExpand = () => {
    setLoading(true);
    let stateArray = [];

    getUsers().then((response) => {
      if (isMountedRef.current) {
        setLoading(false);
        console.log("Users: ", response);
        if (response) {
          setUsers(response);
          response.forEach((element) => {
            if (
              stateArray.filter(
                (s) => s.name === getFieldName(element.businessunitid)
              ).length === 0 &&
              getFieldName(element.businessunitid) !== "ccplive" &&
              getFieldName(element.businessunitid) !== "SAFY of SC CBPS"
            ) {
              stateArray.push({
                _id: getFieldName(element.businessunitid),
                name: getFieldName(element.businessunitid),
              });
            }
          });
          stateArray.sort(sortObjectName);
          setStateOptions(stateArray);
        }
      }
    });
  };

  const sortObjectName = (a, b) => {
    const objectA = a.name.toUpperCase();
    const objectB = b.name.toUpperCase();

    let comparison = 0;
    if (objectA > objectB) {
      comparison = 1;
    } else if (objectA < objectB) {
      comparison = -1;
    }
    return comparison;
  };

  const openReport = () => {
    console.log("Report Org: ", process.env.REACT_APP_ENVIRONMENT);
    const url = `https://safyreports.azurewebsites.net/Reports/NoteSummary/CaseWorker?db=${reportOrg}&b=${reportData.BeginDate}&e=${reportData.EndDate}&c=${reportData.Caseworker}`;
    window.open(url, "Case Worker Note Summary Report");
  };

  return (
    <ReportsExpand
      title="Caseworker Note Summary"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
      onExpand={handleExpand}
    >
      {!loading ? (
        <div className="row">
          <div className="col-3">
            <Select
              name="State"
              label="State"
              options={stateOptions}
              onChange={handleChange}
            />
          </div>
          <div className="col-3">
            <Select
              name="Caseworker"
              label="Caseworker"
              options={caseworkerOptions}
              onChange={handleChange}
            />
          </div>
          <div className="col-2">
            <Input
              name="BeginDate"
              label="Begin Date"
              type="date"
              onChange={handleChange}
              style={{}}
            />
          </div>
          <div className="col-2">
            <Input
              name="EndDate"
              label="End Date"
              type="date"
              onChange={handleChange}
              style={{}}
            />
          </div>
          {reportData.Caseworker !== "" &&
            reportData.BeginDate !== "" &&
            reportData.EndDate !== "" && (
              <i
                className="fas fa-arrow-circle-right fa-3x col col-2 float-end"
                onClick={openReport}
              ></i>
            )}
        </div>
      ) : (
        <>Loading</>
      )}
    </ReportsExpand>
  );
}

export default CaseWorkerNoteSummary;
